<template>
    <div class="info-mosaics-container">       
        <div v-if="mosaicCampaignSelected != null ">
          <div class="panel-content-title">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].name }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].date }}
          </div>
          <div class="panel-content-header">
            Código
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].code }}
          </div>
          <div class="panel-content-header">
            Abstract
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].abstract }}
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].description }}
          </div>
          <div class="panel-content-header">
            Localización
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].location }}
          </div>
          <div class="panel-content-header">
            Objetivo
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].goal }}
          </div>
          <div class="panel-content-header">
            <h5>Datos de la campaña</h5>
            <div class="input-group ">
                <select id="campaign" class="custom-select" v-model="mosaicCampaignDataSelected">
                    <option
                      v-for="(campaignData, index) in mosaicsCampaignsList[mosaicCampaignSelected].mosaicCampaignData"
                      :key="index"
                      :label="campaignData.name"
                      :value="index">
                    </option>
                </select>
              </div>
          </div>
          <div class="panel-content-header">
            Descripción
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected].description }}
          </div>
          <div class="panel-content-header">
              Comentarios
          </div>
          <div class="panel-content-line">
            {{ mosaicsCampaignsList[mosaicCampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected].comments }}
          </div>
          <div class="panel-content-header">
            Fecha
          </div>
          <div class="panel-content-line">
             {{ mosaicsCampaignsList[mosaicCampaignSelected].mosaicCampaignData[mosaicCampaignDataSelected].date }}
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'infoPanelMosaics',
    data: function () {
        return {
          mosaicCampaignDataSelected: 0
        }
    },
    computed: {
      mosaicCampaignSelected: {
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicCampaignSelected }
      },
      mosaicsCampaignsList: {
          set (campaignsList) { this.$store.dispatch('changeMosaicsCampaignsList', {mosaicsCampaignsList: campaignsList}); },
          get () { return this.$store.state.mapLayers.layerMosaics.mosaicsCampaignsList }
      },
    }
  }
</script>

<style scoped>
  .info-mosaics-container {
    width: 100%;
    padding: 0px 10px 10px 18px;
  }
  .global-mosaic-container {
    display: flex;
    flex-direction: column;
  }
  .panel-content-line{
    font-size: small;
    line-height: 80%;
    margin-bottom: 0.8rem;
  }
  .panel-content-header{
    font-size: small;
    line-height: 100%;
    font-weight: 800;
    margin-bottom: 0.5rem;
  }
  .panel-content-title{
    font-weight: 800;
    margin-bottom: 0.5rem;
    color: #00A7E3;
  }
</style>


// WEBPACK FOOTER //
// src/components/map/InfoPanelMosaics.vue